// 본문-주석 매칭 색상 — 셀 배경(Figma green/yellow/rose 200)과
// 칩·상태요약 soft 색을 한 곳에서 관리한다.

/** 셀 배경 채움 (테두리 없이 fill only) */
export const NOTE_REFERENCE_CELL_FILL = {
  positive: "bg-[#b9f8cf]",
  caution: "bg-[#fff085]",
  negative: "bg-[#ffccd3]",
} as const;

/** 다른 셀 선택 중 흐리게 — Figma green/yellow/rose 50 */
export const NOTE_REFERENCE_CELL_FILL_DIM = {
  positive: "bg-[#f0fdf4]",
  caution: "bg-[#fefce8]",
  negative: "bg-[#fff1f2]",
} as const;

/**
 * 하드룰(cash_note_total 등) 연결의 양쪽 셀(베타) — 상태 채움 위에 primary-color 빗금(셀 안 개수 칩·패널 표기와 같은 토큰).
 * 셀을 누르기 전에 표에서 알아보는 장치라 테두리가 아니라 채움 무늬로 구분한다. 상단 범례 견본도 같은 클래스.
 * 토큰이 plain var() 라 `/28` 수식어가 안 먹어 color-mix 로 투명도를 준다
 */
export const NOTE_REFERENCE_HARD_RULE_CELL_CLASS =
  "bg-[repeating-linear-gradient(135deg,transparent_0_6px,color-mix(in_srgb,var(--primary-color)_28%,transparent)_6px_9px)]";

/** 칩·상태요약 soft 배경/글자 */
export const NOTE_REFERENCE_SOFT_CLASS = {
  positive: "bg-green-100 text-emerald-500",
  caution: "bg-yellow-100 text-yellow-600",
  negative: "bg-rose-100 text-rose-500",
} as const;

/** 근거 창(V2) — 후보 셀이 속한 행 전체. 상태 톤의 100 */
export const NOTE_REFERENCE_EVIDENCE_ROW_CLASS = {
  positive: "bg-green-100",
  caution: "bg-yellow-100",
  negative: "bg-rose-100",
} as const;

/** 근거 창(V2) — 후보 셀. 상태 톤의 200 채움 + 500 테두리 */
export const NOTE_REFERENCE_EVIDENCE_CELL_CLASS = {
  positive: `${NOTE_REFERENCE_CELL_FILL.positive} ring-2 ring-green-500 ring-inset`,
  caution: `${NOTE_REFERENCE_CELL_FILL.caution} ring-2 ring-yellow-500 ring-inset`,
  negative: `${NOTE_REFERENCE_CELL_FILL.negative} ring-2 ring-rose-500 ring-inset`,
} as const;
